import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import RegisterFormSection from '../Pages/RegisterFormSection'

const RegisterPopup = ({clearPopup}) => {

    const [openRegister, setRegister] = useState(false)

    return (
        <section className="SpaceIn_Misson_sec position-relative">
            <div className="position-absolute" style={{right: "2rem", top: "1rem", zIndex: "10", cursor: "pointer"}} onClick={() => {
                setRegister(false)
                clearPopup()
                }}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#fff" style={{width: "25px", height:"25px"}}>
                   <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>

            </div>
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-12 col-lg-12">
                        <div className="frame" style={{margin: "0px",zIndex: "1"}}>
                            <div className="frame_contentBox">
                                {
                                    openRegister ? 
                                    <>
                                    <div className="row align-items-baseline">
                                        <div className="col-12 col-md-6 col-lg-6 offset-md-4 offset-lg-4">
                                            <p className="Heading font30">
                                                MEMBERSHIP FORM 
                                            </p>
                                        </div>
                                        <div className="col-12 col-md-2 col-lg-2">
                                            <img src="assets/images/hourglass.png" alt="spaced-in-img1" className="img-fluid vector_img" />
                                        </div>	
                                    </div>
                                    <RegisterFormSection />
                                    </> :
                                    (
                                        <div className="row text-center">
                                            <div className="col-12 col-md-12 col-lg-12">
                                                <div className="headingBg">
                                                    <label className="subHeading font25">
                                                        come into our space to see to new   
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="row align-items-baseline">
                                                <div className="col-12 col-md-2 col-lg-2">
                                                    <img src="assets/images/alien.png" alt="spaced-in-img1" className="img-fluid" />
                                                </div>
                                                <div className="col-12 col-md-8 col-lg-8">
                                                        <p className="Heading font30">
                                                        SPACED iN  
                                                    </p>
                                                    <p className="font20 mt-3">
                                                        Register now, At low price
                                                    </p>
                                                </div>
                                                <div className="col-12 col-md-2 col-lg-2">
                                                    <img src="assets/images/hourglass.png" alt="spaced-in-img1" className="img-fluid" />
                                                </div>	
                                            </div>
                                            {/* <p className="peraBox font14 py-3">
                                                Diam Sit Amet Nisl Suscipit. A Condimentum Vitae Sapien Pellentesque Habitant Morbi Tristique Senectus. Odio Tempor Orci Dapibus Ultrices In Iaculis Nunc Sed. Massa Enim Nec Dui Nunc Mattis Enim Ut Tellus. Mattis Aliquam Faucibus Purus In Massa Tempor Nec Feugiat Nisl. Augue Lacus Viverra Vitae Congue Eu Conseqsnc Sed. Massa Enim Nec Dui Nunc Mattis Enim Ut Tellus. Mattis Aliquam Faucib
                                            </p> */}
                                            <div className="btnWrapper">
                                                {/* <Link to="/Spacedin" className="customBtn">
                                                    <img src="assets/images/btnBg.png" className="img-fluid" />
                                                    <span>
                                                        Register Now <i className="fa-solid fa-arrow-right"></i>
                                                    </span> 
                                                </Link> */}

                                                <Link to="/RegisterForm" className="customBtn"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setRegister(true)
                                                }}
                                                >
                                                    <img src="assets/images/btnBg.png" className="img-fluid" />
                                                    <span>
                                                        Register Now <i className="fa-solid fa-arrow-right"></i>
                                                    </span> 
                                                </Link>
                                            </div>
                                            <p className="font12">
                                                <span style={{fontWeight: "500", fontSize: "15px"}}>Already have an <Link to="/login" style={{textDecoration: "underline !important", fontSize: "15px"}}>account?</Link></span>
                                            </p>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

RegisterPopup.defaultProps = {
    clearPopup: () => {}
}
export default RegisterPopup